import type { Palettes } from 'types/theme';
// import { green } from '@mui/material/colors';

// set MUI theme palette
const palette: keyof Palettes = 'default'; // options defined in LayoutStyles.js

const config = {
  palette,
};

export default config;
